export const requestAnimationFrame = (function () {
  return window.requestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.msRequestAnimationFrame ||
  function (callback) {
    window.setTimeout(callback, 1000 / 60);
  };
})();

export const cancelAnimationFrame = (function () {
  return window.cancelAnimationFrame ||
  window.mozCancelAnimationFrame ||
  function (timer) {
    window.clearTimeout(timer);
  };
})();



// WEBPACK FOOTER //
// ./src/utils/animationFrame.js